import { Form } from '@uplift/types';
import { restClient } from '../../client';

export type GetFormDefinitionOutput =
  | { error: string }
  | { definition: Form };

export const getFormDefinition = (formId: string) =>
  restClient.request<GetFormDefinitionOutput>('/api/v1/form/definition', {
    method: 'POST',
    data: {
      form_id: formId
    }
  });
